import styled from 'styled-components';

type SaveTextProps = {
  text: string;
  disabled?: boolean;
  onClick?: () => void;
} & Omit<React.HTMLAttributes<HTMLSpanElement>, 'onClick' | 'disabled'>;

export function SaveText({
  text,
  disabled = false,
  onClick,
  ...props
}: SaveTextProps) {
  return (
    <Wrapper
      disabled={disabled}
      onClick={() => {
        if (disabled) return;
        onClick && onClick();
      }}
      {...props}
    >
      {text}
    </Wrapper>
  );
}

const Wrapper = styled.span<{ disabled: boolean }>`
  cursor: pointer;
  color: ${({ theme, disabled }) =>
    disabled ? theme.palette.gray300 : theme.palette.brand300};
  font-weight: 500;
`;
